import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WebSocketState } from './websocket.state';

export const selectWebSocketState =
  createFeatureSelector<WebSocketState>('webSocket');

export const selectSocketConnected = createSelector(
  selectWebSocketState,
  (state) => state.connected
);

export const selectSocketConnectionStatus = createSelector(
  selectWebSocketState,
  (state) => state.connectionStatus
);

export const selectSocketError = createSelector(
  selectWebSocketState,
  (state) => state.error
);

export const selectSubscribedChannelIds = createSelector(
  selectWebSocketState,
  (state) => state.subscribedChannelIds
);

export const selectMessagesByChannelMap = createSelector(
  selectWebSocketState,
  (state) => state.messagesByChannel
);

export const selectMessagesForChannel = (channelId: string) =>
  createSelector(selectMessagesByChannelMap, (messagesByChannel) => {
    const channelState = messagesByChannel[channelId];
    if (!channelState) {
      return [];
    }

    return channelState.ids
      .map((id) => channelState.entities[id])
      .filter(Boolean)
      .sort((a, b) => {
        const left = new Date(a.created_at).getTime();
        const right = new Date(b.created_at).getTime();
        return left - right;
      });
  });

export const selectPendingMessages = createSelector(
  selectWebSocketState,
  (state) => state.pendingMessages
);

export const selectPendingMessagesForChannel = (channelId: string) =>
  createSelector(selectPendingMessages, (pending) =>
    Object.values(pending)
      .filter((item) => item.channelId === channelId)
      .sort((a, b) => {
        const left = new Date(a.createdAt).getTime();
        const right = new Date(b.createdAt).getTime();
        return left - right;
      })
  );